import Divider from '@/component/Divider'
import TGASDK from '@/config/TGASDK'
import useRuntime from '@/hook/useRuntime'
import { getLocalLang } from '@/i18n'
import type { I18nText } from '@kulee/tga-sdk/types/types/common'
import React, { useEffect, useState } from 'react'
import NavItem, { NavItemType } from '../NavItem'

const TagList: React.FC<PropType> = () => {
  const { path } = useRuntime()
  const [section, setSection] = useState<string>()
  const language = getLocalLang()

  const { quickAccessList = [] } = TGASDK.context.appConfig.page

  const getName = (data: I18nText[]) => {
    return data.find(item => item.lang.toLowerCase() === language.toLowerCase())?.values || data[0].values || ''
  }

  const colums: NavItemType[] = quickAccessList.map(item => {
    return {
      name: getName(item.name),
      link: item.link,
      icon: item.svgIcon
    }
  })

  useEffect(() => {
    setSection(path.split('/').filter(Boolean).pop())
  }, [path])

  return (
    <>
      {colums.map((item, index) => {
        return <NavItem item={item} key={index} />
      })}
      <Divider />
      <NavItem
        item={{
          code: 'allTag',
          iconCode: 'tag.svg',
          link: '/tags/'
        }}
      />
    </>
  )
}

interface PropType {}

export default TagList
